import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Delivery from '../views/Delivery.vue';
import Driver from '../views/Driver.vue';
import Customer from '../views/Customer.vue';
import Tracking from '../views/Tracking.vue';
import Config from '../views/Config.vue';
import DistributionCenter from '../views/DistributionCenter.vue';
import Vehicle from '../views/Vehicle.vue';
import Routing from '../views/Routing.vue';
import Report from '../views/Report.vue';
import PageNotFound from '../views/PageNotFound.vue';

import AdminAdmin from '../views_admin/AdminAdmin.vue';
import AdminCompany from '../views_admin/AdminCompany.vue';
import AdminCustomer from '../views_admin/AdminCustomer.vue';
import AdminDrivers from '../views_admin/AdminDrivers.vue';
import AdminExternalAccess from '../views_admin/AdminExternalAccess.vue';
import AdminLog from '../views_admin/AdminLog.vue';
import AdminSetting from '../views_admin/AdminSetting.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/delivery',
		name: 'Delivery',
		component: Delivery
	},
	{
		path: '/driver',
		name: 'Driver',
		component: Driver
	},
	{
		path: '/customer',
		name: 'Customer',
		component: Customer
	},
	{
		path: '/tracking',
		name: 'Tracking',
		component: Tracking
	},
	{
		path: '/config',
		name: 'Config',
		component: Config
	},
	{
		path: '/distribution_center',
		name: 'DistributionCenter',
		component: DistributionCenter
	},
	{
		path: '/vehicle',
		name: 'Vehicle',
		component: Vehicle
	},
	{
		path: '/routing',
		name: 'Routing',
		component: Routing
	},
	{
		path: '/report',
		name: 'Report',
		component: Report
	},




	
	{
		path: '/admin/admin',
		name: 'AdminAdmin',
		component: AdminAdmin
	},
	{
		path: '/admin/company',
		name: 'AdminCompany',
		component: AdminCompany,
	},
	{
		path: '/admin/customer',
		name: 'AdminCustomer',
		component: AdminCustomer,
	},
	{
		path: '/admin/drivers',
		name: 'AdminDrivers',
		component: AdminDrivers,
	},
	{
		path: '/admin/externalaccess',
		name: 'AdminExternalAccess',
		component: AdminExternalAccess,
	},
	{
		path: '/admin/log',
		name: 'AdminLog',
		component: AdminLog,
	},
	{
		path: '/admin/setting',
		name: 'AdminSetting',
		component: AdminSetting,
	},






	{
		path: '/:catchAll(.*)*',
		name: "PageNotFound",
		component: PageNotFound,
	},




//	{
//		path: '/about',
//		name: 'About',
//		// route level code-splitting
//		// this generates a separate chunk (about.[hash].js) for this route
//		// which is lazy-loaded when the route is visited.
//		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
//	}
]

const router = new VueRouter({
	//mode: 'history',
	routes
})

export default router
